import Bol from "./Bol";

export default Bol;
